
/*
 * -------------------------------------------------------------------------------
 * SITE HEADER FUNCTIONS STARTS
 * ---------------------------------------------------------------------------------
 */

function overAllSiteHeaderFunctions() {
    //$("#wcs-shipping-van").css("margin-left",((($("#wcs-shipping-container").width())/2) - ($("#wcs-shipping-van").width()+$(".wcs-shipping-bar-text").width())/2)+50);
   /**===DMP French pages quick fix: Start====*/
   if ($('html').attr('lang') === 'fr-CA') {
       $('body').addClass('wcs-fr_CA');
   }
   /**===DMP French pages quick fix: End ===*/

   /* target iPad and Android*/

   var userAgent = navigator.userAgent.toLowerCase();
   if (userAgent.match(/ipad/i) !== null) {
       $('body').addClass('ipad');
   } else if (userAgent.match(/android/i) !== null) {
       $('body').addClass('android');
   }

   if (userAgent.match(/gt-n8010/i) !== null) {
       $('body').addClass('gt-n8010');
   }
   if (is_ie10) {
       $('body').addClass("ie10");
   }
   var head_nav = $(".wcs-primary.wcs_on"),
      title_links = $(".wcs-hd-menu .wcs-primary.wcs_on > a"),
      title_links_off = $(".wcs-hd-menu .wcs-primary.wcs_off"),
      menu = $(".wcs-hd-menu-items"),
      drop_panel = $(".wcs-drop_panel"),
      down_arrow = $(".wcs-header .wcs-down_arrow"),
      fadeout = $(".wcs-fadeout"),
      timer;

   var highlightSelected = function () {
     if (!$('.wcs-hd-menu-search').hasClass('active')) {
       title_links
         .filter('.wcs-selected')
         .find('.wcs-down_arrow')
         .css('display', 'block').animate({
           top: top
         }, 0);
     }
   };

 var removeHighlight = function () {
   title_links
     .filter('.wcs-selected')
     .find('.wcs-down_arrow')
     .hide()
     .css('top', '-8px');
 };

   var arrowRight = $('.arrow-after');
   var arrowLeft = $('.arrow-before');
   $('.desktopdropdowndisplay > div').hover(
       function() {
           var scroller = $(this).parents('.rb-header-dropdown-most-popular');
           var sectionWidth = $(this).parents('.desktopdropdowndisplay').width();
           var leftPos = scroller.scrollLeft();
           if(sectionWidth < window.innerWidth) {
               arrowLeft.hide();
               arrowRight.hide();
           } else {
               if ((scroller[0].scrollWidth - scroller.innerWidth()) === Math.round(scroller.scrollLeft())) {
                   arrowRight.hide();
               } else {
                   arrowRight.show();

               }
               if (leftPos === 0) {
                   arrowLeft.hide();
               } else {
                   arrowLeft.show();
               }
           }
       }, function() {
           arrowLeft.hide();
           arrowRight.hide();
       }
   );

   $('.rb-header-dropdown-most-popular').scroll(function (e) {
       var scrollPosition = $(this).scrollLeft();
       if (($(this)[0].scrollWidth - $(this).innerWidth()) === Math.round($(this).scrollLeft())) {
           arrowRight.hide();
       } else {
           arrowRight.show();
       }
       if (scrollPosition === 0) {
           arrowLeft.hide();
       } else {
           arrowLeft.show();
       }
     });

   arrowRight.click(function () {
      var leftPos = $(this).parents('.rb-header-dropdown-most-popular').scrollLeft();
      $(this).parents(".rb-header-dropdown-most-popular").animate({
        scrollLeft: leftPos + 400
      }, 500);
   });

   arrowLeft.click(function () {
      var leftPos = $(this).parents('.rb-header-dropdown-most-popular').scrollLeft();
      $(this).parents(".rb-header-dropdown-most-popular").animate({
        scrollLeft: leftPos - 400
      }, 500);
   });

   $(".arrow-after, .arrow-before").hover(function () {
       var scroller = $(this).parents('.rb-header-dropdown-most-popular');
       var leftPos = scroller.scrollLeft();
       if ((scroller[0].scrollWidth - scroller.innerWidth()) === Math.round(scroller.scrollLeft())) {
          scroller.find('.arrow-after').hide();
       } else {
          scroller.find('.arrow-after').show();
       }
       if (leftPos === 0) {
          scroller.find('.arrow-before').hide();
       } else {
          scroller.find('.arrow-before').show();
       }
   });

  title_links_off.hover(function () {
    title_links.removeClass('wcs-active');
    menu.removeClass('menu-hover');
    drop_panel.hide();
    down_arrow.hide().animate({
      top: -8
    }, 0);
    fadeout.css('height', '').addClass('wcs-hide');
    $(this)
      .find('.wcs-down_arrow')
      .css('display', 'block').animate({
        top: top
      }, 0);
      if ($('body').attr('id') === 'plp' && !$('.wcs-hd-menu-search').hasClass('active')) {
      title_links
        .filter('.wcs-selected').siblings(".wcs-drop_panel").css({
          "display": "block"
        });
      }
  }, function () {
    down_arrow.hide().animate({
      top: -8
    }, 0);
  });

   /* header menu HOVER function */
   head_nav.hover(function() {
     if (!$('wcs-hd-menu-search').hasClass('active')) {
       head_nav.removeClass('wcs-hover');
       $(this).addClass('wcs-hover');
       if ($('body').attr('id') !== 'plp' || ($('body').attr('id') === 'plp' && $('.wcs-hd-menu-search').hasClass('active'))) {
       fadeout.css('top', $('header').offset().top + $('header').outerHeight(true) + 'px');
       }
     }
   }, function() {
        head_nav.removeClass('wcs-hover');
   });
   /* header menu CLICK function */
   window.close_header_drop_panel = function() {
    clearTimeout(timer);
    down_arrow.hide().css('top', '-8px');
    title_links.removeClass('wcs-active');
    highlightSelected();
   };

   var initiate_menu = function ($this, f) {
     var downArrow;
     f.preventDefault();
     removeHighlight();
     downArrow = $($this).addClass('wcs-active').find(down_arrow);
     var top = 0;
     if ($('body').hasClass('android')) {
       top = -1;
     }
     if (!drop_panel.is(":visible")) {
       var dHeight = $(document).height();
       if (!menu.hasClass("menu-hover")) {
         $($this).siblings(drop_panel).slideDown(500);
         menu.addClass("menu-hover");
         if ($('.wcs-shipping-bar').is(':visible')) {
           slide_back_rightPanel();
           if ($('body').attr('id') !== 'plp' || ($('body').attr('id') === 'plp' && $('.wcs-hd-menu-search').hasClass('active'))) {
            fadeout.removeClass('wcs-hide').css({
              "height": dHeight - 106 + "px"
            });
            }
         } else {
           slide_back_rightPanel();
           if ($('body').attr('id') !== 'plp' || ($('body').attr('id') === 'plp' && $('.wcs-hd-menu-search').hasClass('active'))) {
            fadeout.removeClass('wcs-hide').css({
              "height": dHeight - 75 + "px"
            });
            }
         }
       }
      title_links.removeClass('wcs-active');
      downArrow.css('display', 'block').animate({
        top: top
      }, 0);
     } else if (!$($this).siblings(drop_panel).is(":visible")) {
       var Drop_down_time = setTimeout(function () {
         if (($($this).parent().hasClass('rb-header-optics') && !$('.wcs-sunglass').hasClass("dropdown_sunglass_open") && !$('.wcs-customize').hasClass("dropdown_customize_open")) || ($($this).parent().hasClass('rb-header-sunglasses') && !$('.wcs-optics').hasClass("dropdown_optics_open") && !$('.wcs-customize').hasClass("dropdown_customize_open")) || ($($this).parent().hasClass('rb-header-customize') && !$('.wcs-sunglass').hasClass("dropdown_sunglass_open") && !$('.wcs-optics').hasClass("dropdown_optics_open"))) {
          if (!$($this).siblings(drop_panel).is(":visible")) {
            title_links.removeClass('wcs-active');
            drop_panel.hide();
            down_arrow.hide().animate({
              top: -8
            }, 0);
            $($this).addClass('wcs-active').siblings(drop_panel).show();
            downArrow.css('display', 'block').animate({
              top: top
            }, 0);
          }
         } else {
           clearTimeout(Drop_down_time);
         }
        }, 300);
      }
   };

  $(drop_panel).hover(
      function () {
        if ($(this).hasClass('wcs-sunglass')) {
          $(this).addClass('dropdown_sunglass_open');
        } else if ($(this).hasClass('wcs-optics')) {
          $(this).addClass('dropdown_optics_open');
        } else if ($(this).hasClass('wcs-customize')) {
          $(this).addClass('dropdown_customize_open');
        }
      }, function () {
        if ($(this).hasClass('wcs-sunglass')) {
          $(this).removeClass('dropdown_sunglass_open');
        } else if ($(this).hasClass('wcs-optics')) {
          $(this).removeClass('dropdown_optics_open');
        } else if ($(this).hasClass('wcs-customize')) {
          $(this).removeClass('dropdown_customize_open');
        }
      }
    );


   if ($('body').hasClass('android')) {
       title_links.off("click.android_hover").on("click.android_hover", function(f) {
           if ($(this).siblings(drop_panel).length > 0 && !$(this).siblings(drop_panel).is(':visible')) {
               initiate_menu(this, f);
           }
       });
   } else {
       title_links.off("mouseover.wcs").on("mouseover.wcs", function (f) {
         // If mouseover is on remix, then change the height of the drop panel container
         if (menu.hasClass("menu-hover")) {
           initiate_menu(this, f);
         } else {
           var that = this;
           timer = setTimeout(function () {
             initiate_menu(that, f);
           }, 300);
         }
       });
   }

   $('.rb-header .wcs-primary').mouseleave(function () {
     var Drop_down_time = setTimeout(function () {
      if (($(this).parent().hasClass('rb-header-optics') && !$('.wcs-sunglass').hasClass("dropdown_sunglass_open") && !$('.wcs-customize').hasClass("dropdown_customize_open")) || ($(this).parent().hasClass('rb-header-sunglasses') && !$('.wcs-optics').hasClass("dropdown_optics_open") && !$('.wcs-customize').hasClass("dropdown_customize_open")) || ($(this).parent().hasClass('rb-header-customize') && !$('.wcs-sunglass').hasClass("dropdown_sunglass_open") && !$('.wcs-optics').hasClass("dropdown_optics_open"))) {
        removeHighlight();
        if ($('body').attr('id') !== 'plp') {
        close_header_drop_panel();
        } else {
        $(this).find('.wcs-down_arrow').hide().css('top', '-8px');
        //highlightSelected();
        }
      } else {
        clearTimeout(Drop_down_time);
      }
     }, 300);
   });

   menu.mouseleave(function () {
    if ($('body').attr('id') !== 'plp') {
      drop_panel.slideUp(500);
      $(this).find('.wcs-down_arrow').hide().css('top', '-8px');
      if ($('body').attr('id') !== 'plp' || ($('body').attr('id') === 'plp' && $('.wcs-hd-menu-search').hasClass('active'))) {
      fadeout.css('height', '').addClass('wcs-hide');
      }
      menu.removeClass("menu-hover");
      clearTimeout(timer);
    } else {
      if (!$('.wcs-hd-menu-search').hasClass('active')) {
        drop_panel.hide();
        if ($('body').attr('id') !== 'plp' || ($('body').attr('id') === 'plp' && $('.wcs-hd-menu-search').hasClass('active'))) {
        fadeout.css('height', '').addClass('wcs-hide');
        }
        menu.removeClass("menu-hover");
        down_arrow.hide().css('top', '-8px');
        title_links
          .filter('.wcs-selected').siblings(".wcs-drop_panel").css({
            "display": "block"
          });
        highlightSelected();
      } else {
         menu.removeClass('menu-hover');
         title_links
           .filter('.wcs-active').siblings(".wcs-drop_panel").css({
             "display": "none"
           });
        fadeout.css('height', '').addClass('wcs-hide');
      }
    }
   });

   if ($('.wcs-shipping-bar').is(':visible')) {
       $(".wcs-drop_panel, .wcs-drop_panel_container, .wcs-fadeout").addClass('wcs-top106');
   } else {
       $(".wcs-drop_panel, .wcs-drop_panel_container, .wcs-fadeout").removeClass('wcs-top106');
   }

   var product_type = $('#producttype').val();
   product_type = product_type || "";
   product_type = product_type.toLowerCase();

  if (product_type.indexOf('sunglasses') != -1 && !(product_type.indexOf('special-edition') != -1) && !($('#pageTemplate').val() === "CategoryLanding")) {
       $('.wcs-hd-container .wcs-sunglass').siblings('a').addClass('wcs-selected');
  } else if (product_type == 'optics' || product_type == 'eyeglasses' || product_type.indexOf('eyeglasses') != -1 && !($('#pageTemplate').val() === "CategoryLanding")) {
       $('.wcs-hd-container .wcs-optics').siblings('a').addClass('wcs-selected');
   } else if (product_type == 'remix') {
       $('.wcs-hd-container .wcs-remix').siblings('a').addClass('wcs-selected');
   }
   $("#a_Virtual_Mirror").mouseover(function(){
       close_header_drop_panel();
   });

 $(document).ready(function() {
    highlightSelected();
    if($('body').attr('id') === 'plp'){
      $('.wcs-product-title').addClass('menu-open-plp');
      if ($('#ab-promo-stripe').length) {
        $('.wcs-product-title').addClass('promo-stripe-active');
      }
      title_links
      .filter('.wcs-selected').siblings(".wcs-drop_panel").css({"display": "block"});
      var product_type = $('#producttype').val();
      //product_type = product_type.replace('_', '/');
      //product_type_splitted = product_type.split('_')[1];
      $('.simpleLink_Carousel,.fullLink_Carousel').each(function(  ) {
      if ($(this).find('a').attr('data-description') !== undefined && $(this).find('a').attr('data-description') === product_type)
        $(this).append('<span class="black-bottom"></span>');
      });
      var promobar = $('#ab-promo-stripe');
      if (promobar.length !== 0) {
        promobar.css('margin-top', $('#wcs-drop-down-new-panel').innerHeight() + 'px');
      }
    }
    });
}

lastScrollTop = 0;
var finalHeaderHeight = 0;

window.onscroll = function () {
   var cookieMsg = $(".wcs-top-message-container");
   var cookieMsgHeight = cookieMsg.length ? cookieMsg.height() : 0;
   var shippingBar = $('.wcs-shipping-bar');
   var shippingBarHeight = shippingBar.outerHeight();
   var currentHeader = $(".rb-header-standard");
   var currentHeaderHeight = currentHeader.height();

   var promoBar = $('#ab-promo-stripe');
   var promoActive = $('#ab-promo-stripe').length > 0;
   var promoBarHeight = $('#ab-promo-stripe').length ? $('#ab-promo-stripe').height() : 0;
   if (promoBarHeight != 0) {
      var promoTop = $('#ab-promo-stripe').css('padding-top');
      promoTop = parseInt(promoTop);
      var promoBottom = $('#ab-promo-stripe').css('padding-bottom');
      promoBottom = parseInt(promoBottom);
      promoBarHeight = promoBarHeight+promoTop+promoBottom;
    }

   var miniHeader = $('.rb-header .wcs-hd-container');
   var miniHeaderHeight = $('.rb-header .wcs-hd-container').length ? $('.rb-header .wcs-hd-container').height() : 0;

   var isHeaderSticky = true;
   var pageLabel = $("#pageLabel").val();
   if(pageLabel == 'plp' || pageLabel == 'PDP' || pageLabel == '' || pageLabel == undefined){
       if(pageLabel == ''){
           var pageLabelSticky = $('#pageLabelForSticky').val();
           if(pageLabelSticky == 'myAccount' || pageLabelSticky == 'shoppingCart' || pageLabelSticky == 'searchResultsPage'){
               isHeaderSticky = false;
           }
       } else {
           isHeaderSticky = false;
       }
   }

   var scrollValue = $(window).scrollTop();

   if ($('header').hasClass('rb-header-standard')) {
       if (isHeaderSticky && scrollValue > (cookieMsgHeight + shippingBarHeight + miniHeaderHeight)) {
           if(promoActive && scrollValue < (lastScrollTop - 10)) {
               miniHeader.addClass("sticky");
               promoBar.removeClass("sticky");
               finalHeaderHeight = miniHeaderHeight;
           } else if(promoActive && scrollValue > (lastScrollTop + 10)) {
               miniHeader.removeClass("sticky");
               promoBar.addClass("sticky");
               finalHeaderHeight = promoBarHeight;
           }

           lastScrollTop = scrollValue;

           $('.header-spacer').css({
               'height': finalHeaderHeight,
               'position': 'relative',
           });

       } else if (promoActive && scrollValue > (cookieMsgHeight + shippingBarHeight) && scrollValue <= (cookieMsgHeight + shippingBarHeight + miniHeaderHeight) && miniHeader.hasClass("sticky")){
               miniHeader.addClass("sticky");
               promoBar.removeClass("sticky");
       } else {
           if(promoActive){
               miniHeader.removeClass("sticky");
               promoBar.removeClass("sticky");
           } else {
               currentHeader.removeClass("sticky");
           }

           $('.header-spacer').css({
               'height': '0',
           });
           lastScrollTop = 0;
       }
       if(!promoActive && scrollValue > (cookieMsgHeight + shippingBarHeight) && $('body').attr('id') != 'plp') {
             currentHeader.addClass("sticky");
             finalHeaderHeight = currentHeaderHeight;
             $('.header-spacer').css({
               'height': finalHeaderHeight,
           });
         }
   }
};

/*Analytics-Header Drop down code*/

$('#HeaderDN_Logout').off("click").on("click", function(e) {
   var userType = $('#userType').val();
   var pageval = $('#page').val();
   if(document.cookie.indexOf("xvtouser")!==-1){
       document.cookie = 'xvtouser' + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
   }

   $.cookie('activePanel','0', { path: '/' });
});

/*piece of code used to navigate the menu with the keyboard*/

$('.rb-header .wcs-right-slider-nav button').keyup(function (e) {
 var code = (e.keyCode ? e.keyCode : e.which);
 if (code == 9) {
   $(this).css('outline', '5px auto -webkit-focus-ring-color');
 }
});
$('.rb-header .wcs-right-slider-nav button').focusout(function (e) {
 $(this).css('outline', 'none');
});

$('.wcs-hd-menu-items > div > a').on('focus', function (event) {
 $('.wcs-drop_panel').each(function (index) {
   $(this).hide();
 });
 $(this).siblings('.wcs-drop_panel').show();
});

$('.wcs-right-slider-nav button').on('focus', function (event) {
 $('.wcs-drop_panel').each(function (index) {
   $(this).hide();
 });
});

/*---------------------------------------------------------------------------
                                   SITE HEADER FUNCTIONS ENDS
           ----------------------------------------------------------------------------*/
